module.exports = __webpack_public_path__ + "assets/14a4e241dda298c56f50629f2f224193.png";